import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CategorySelector from './CategorySelector';
import './ServicesWrapper.css';
import DebouncedSearch from '../../generic-components/DebouncedSearch/DebouncedSearch';
import { LANGUAGE } from '../../utils/languageProperties';

const ServicesWrapper = () => {
    const [selectedCategoryName, setSelectedCategoryName] =
        useState<string>('');
    const [searchValue, setSearchValue] = useState('');

    return (
        <div className="services-page">
            <div className="services-header">
                <h2>{LANGUAGE['service-offering-heading']}</h2>
                <DebouncedSearch
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    placeholder={LANGUAGE['search-input-placeholder']}
                />
            </div>

            <CategorySelector
                setSelectedCategoryName={setSelectedCategoryName}
                setSearchValue={setSearchValue}
            />

            <div className="services-content">
                <Outlet
                    context={{
                        selectedCategoryName,
                        searchValue,
                        setSearchValue
                    }}
                />
            </div>
        </div>
    );
};

export default ServicesWrapper;
